/* Make It Lab - Home: returning visitors see "Pick up where you left off" before best sellers. */
(function () {
  function init() {
    var best = document.querySelector('[id$="__mil_best"]');
    var rv = document.querySelector('[id$="__recently_viewed"]');
    if (!best || !rv || rv.getAttribute('data-mil-moved')) return;
    var moved = false;
    var mo = null;
    function check() {
      if (moved) return;
      var n = rv.querySelectorAll('.product-item').length;
      if (n >= 2 && rv.offsetHeight > 0 && (rv.compareDocumentPosition(best) & Node.DOCUMENT_POSITION_PRECEDING)) {
        best.parentNode.insertBefore(rv, best);
        rv.setAttribute('data-mil-moved', '1');
        rv.classList.add('mil-rv-first');
        moved = true;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'home_recently_viewed_first', items_shown: n });
        } catch (e) {}
        if (mo) mo.disconnect();
      }
    }
    if ('MutationObserver' in window) {
      mo = new MutationObserver(check);
      mo.observe(rv, { childList: true, subtree: true });
      setTimeout(function () { if (mo) mo.disconnect(); }, 5000);
    }
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();